import {
    CardNumberElement,
    CardExpiryElement,
    CardCVCElement,
    PostalCodeElement,
    StripeProvider,
    Elements,
    injectStripe,
} from 'react-stripe-elements';
import React, {Component} from 'react';
import Loader from 'react-loader-spinner';
import {Tooltip} from 'reactstrap';
import scrollToComponent from 'react-scroll-to-component';
import StripeService from "./services/StripeService";
import ReactDOM from "react-dom";
import Wizard from "./Wizard";

const createOptions = (fontSize, padding) => {
    return {
        style: {
            base: {
                fontSize,
                fontWeight: '400',
                color: '#424770',
                letterSpacing: '1px',
                '::placeholder': {
                    color: '#aab7c4',
                    fontWeight: '100',
                },
                padding,
            },
            invalid: {
                color: '#9e2146',
            },
        },
    };
};


class _SplitForm extends React.Component {
    constructor(props) {
        super(props);

        this.stripeService = new StripeService();

        this.localState = this.props.localState;

        this.state = {
            tooltipOpen: false,
            loading: false,
            name: '',
            paymentSuccess: false,
            paymentError: this.props.paymentError || false,
            paymentMessage: this.props.paymentError || '',
            disabled: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value,
            disabled: false
        })
    }

    handleSubmit(ev) {
        ev.preventDefault();
        this.setState({
            paymentSuccess: false,
            paymentError: false,
            message: '',
            disabled: true
        });
        if (this.props.stripe) {
            this.setState({loading: true});
            this.props.stripe
                .createToken({name: this.state.name})
                .then((payload) =>
                    this.stripeService.executeAdditionalPayment(payload.token, this.props.payment)
                        .then((response) => {
                            let payment = response.data.payment;

                            // this.setState({
                            //     loading: false,
                            //     paymentSuccess: true,
                            //     message: response.data.message
                            // }, () =>  {
                            //     if (window.innerWidth <= 760) {
                            //         scrollToComponent(this.ResInfo, {
                            //             offset: 0,
                            //             align: 'middle',
                            //             duration: 500,
                            //             ease: 'inExpo'
                            //         });
                            //     }
                            // setTimeout(function() { //Start the timer
                            //     window.location.href = `/${payment}/additional-payment-success` //After 1 second, redirect
                            // }, 3000)
                            // })

                            // if 3d secure (strong authentication) is not supported submit regular payment request via PaymentController@charge
                            if (response.data.three_d_secure.three_d_secure === 'not_supported') {
                                this.props.stripe
                                    .createToken({name: this.state.name})
                                    .then((payload) =>
                                        this.stripeService.executeNonStrongPayment(payload.token, this.localState)
                                            .then((res) => {
                                                this.setState({
                                                    loading: false,
                                                    paymentSuccess: true,
                                                    message: res.data.message,
                                                    checked: false
                                                }, () => {
                                                    let orderId = res.data.order;
                                                    sessionStorage.clear();
                                                    if (window.innerWidth <= 760) {
                                                        scrollToComponent(this.ResInfo, {
                                                            offset: 0,
                                                            align: 'middle',
                                                            duration: 500,
                                                            ease: 'inExpo'
                                                        });
                                                    }
                                                    setTimeout(function () { //Start the timer
                                                        window.location.href = `/${orderId}/payment-success` //After 1 second, redirect
                                                    }, 3000)
                                                })
                                            })
                                    );

                            }

                            // if 3d secure (strong authentication) is supported/required/optional submit payment via PaymentScaController@charge
                            if (response.data.three_d_secure.three_d_secure === 'required' ||
                                response.data.three_d_secure.three_d_secure === 'recommended' ||
                                response.data.three_d_secure.three_d_secure === 'optional') {

                                return window.location.href = response.data.redirect.url;
                            }
                        })

                        .catch((err) => {
                                // console.log(err);
                                this.setState({
                                    loading: false,
                                    disabled: false,
                                    paymentError: true,
                                    message: err.response.data.message
                                })
                            }
                        )
                )
                .catch(err => {
                    this.setState({
                        loading: false,
                        disabled: false,
                        paymentSuccess: true,
                        message: 'Something went wrong.'
                    })
                })

        } else {
            console.log("Stripe.js hasn't loaded yet.");
        }
    };


    render() {
        return (
            <section id='payment'>
                <div className='container py-5'>
                    <div className="row justify-content-center pb-3">
                        <h2 className="wizard-heading">Additional Payment</h2>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-9">
                            <div className="card">
                                <div className="card-body card-wizard">
                                    <div className="row" ref={(section) => {
                                        this.ResInfo = section;
                                    }}>
                                        <div className="col-12">
                                            {this.state.paymentSuccess &&
                                            <div className="alert alert-success">{this.state.message}</div>
                                            }
                                            {this.state.paymentError &&
                                            <div className="alert alert-danger">{this.state.paymentMessage}</div>
                                            }
                                        </div>
                                    </div>
                                    <form onSubmit={this.handleSubmit} id="stripeForm">
                                        <div className="form-group row">
                                            <div className="col-md-3 payment-name-label">
                                                <label className='wizard-label'>
                                                    <small>Cardholder name <i className='fa fa-asterisk'> </i></small>
                                                </label>
                                            </div>
                                            <div className="col-md-9">
                                                <input type="text"
                                                       name='name'
                                                       onChange={this.handleInputChange}
                                                       value={this.state.name}
                                                       className='form-control payment-name'
                                                       placeholder='Your name...'/>
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <div className="col-md-3">
                                                <label className='wizard-label'>
                                                    <small>Card number <i className='fa fa-asterisk'> </i></small>
                                                </label>
                                            </div>
                                            <div className="col-md-9">
                                                <CardNumberElement
                                                    {...createOptions(this.props.fontSize)}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <div className="col-md-3">
                                                <label className='wizard-label'>
                                                    <small>Expiration date <i className='fa fa-asterisk'> </i></small>
                                                </label>
                                            </div>
                                            <div className="col-md-9">
                                                <CardExpiryElement
                                                    {...createOptions(this.props.fontSize)}
                                                />
                                            </div>

                                        </div>
                                        <div className="form-group row">
                                            <div className="col-md-3">
                                                <label className='wizard-label'>
                                                    <small>CVC <i className='fa fa-asterisk'> </i>
                                                        <i className='fa fa-question-circle pl-1' id="TooltipExample"> </i>
                                                        <Tooltip placement="right" isOpen={this.state.tooltipOpen} target="TooltipExample" toggle={this.toggle}>
                                                            <div><small>The CVV Number on your credit or debit card is a 3 digit number located on the back of your card.</small></div>
                                                            <div className='pb-2'><img className='img img-fluid img-responsive' src="assets/img/cvv-caption_new.png" alt="cvv_image"/></div>
                                                        </Tooltip>
                                                    </small>
                                                </label>
                                            </div>
                                            <div className="col-md-9">
                                                <CardCVCElement
                                                    {...createOptions(this.props.fontSize)}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <div className="col-md-3">
                                                <label className='wizard-label'>
                                                    <small>Postcode <i className='fa fa-asterisk'> </i></small>
                                                </label>
                                            </div>
                                            <div className="col-md-9">
                                                <PostalCodeElement placeholder={'Postcode'}
                                                                   {...createOptions(this.props.fontSize)}
                                                />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12 text-right">
                                                <p style={{color: '#FDB913'}}><strong>Total to pay: &#163;{this.props.payment.amount / 100}</strong></p>
                                            </div>
                                        </div>

                                        <div className="form-group text-right">
                                            <button className='btn btn-round btn-payment'
                                                    onClick={(ev) => this.handleSubmit(ev)} disabled={this.state.disabled}>
                                                <div className='d-flex flex-row justify-content-center'>
                                                    {this.state.loading &&
                                                    <div style={{
                                                        display: 'inline-block',
                                                        paddingRight: '5px',
                                                    }}>
                                                        <Loader type="Oval" color="#514f4c" height={15} width={15}/>
                                                    </div>
                                                    }
                                                    <div>Pay</div>
                                                </div>
                                            </button>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

const SplitForm = injectStripe(_SplitForm);

class Checkout extends React.Component {
    constructor(props) {
        super(props);
        // this.state = {
        //     elementFontSize: window.innerWidth < 450 ? '14px' : '18px',
        // };
        // window.addEventListener('resize', () => {
        //     if (window.innerWidth < 450 && this.state.elementFontSize !== '14px') {
        //         this.setState({elementFontSize: '14px'});
        //     } else if (window.innerWidth >= 450 && this.state.elementFontSize !== '18px') {
        //         this.setState({elementFontSize: '18px'});
        //     }
        // });
    }

    render() {
        const fonts = [{cssSrc: "https://fonts.googleapis.com/css?family=Comfortaa:300,400,700"}];
        // const {elementFontSize} = this.state;
        return (
            <div className="Checkout">
                <SplitForm payment={this.props.payment} paymentError={this.props.paymentError}/>
            </div>
        );
    }
}


export default class AdditionalPayment extends Component {
    render() {
        const fonts = [{cssSrc: "https://fonts.googleapis.com/css?family=Comfortaa:300,400,700"}];

        return (
            <StripeProvider apiKey={this.props.stripe_key} paymentError={this.props.paymentError}>
                <Elements fonts={fonts}>
                    <Checkout payment={this.props.payment} paymentError={this.props.paymentError}/>
                </Elements>
            </StripeProvider>
        );
    }

};
// ReactDOM.render(<App />, document.querySelector('.App'));

// class Payment extends Component {
//     render() {
//         return (
//             <section id='confirmation'>
//                 <div className='container pb-5'>
//                     <div className="row justify-content-center pb-3">
//                         <h2 className="wizard-heading">Payment</h2>
//                     </div>
//                     <div className="row justify-content-center">
//                         <div className="card">
//                             <div className="card-body card-wizard">
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         );
//     }
// }
//
//
//
if (document.getElementById('stripePayment')) {
    let element = document.getElementById('stripePayment');
    ReactDOM.render(<AdditionalPayment
        stripe_key={element.dataset.stripe_key}
        payment={JSON.parse(element.dataset.payment)}
        paymentError={element.dataset.payment_error}
    />, element);
}


